import React from "react";
import { Link, Redirect } from "react-router-dom";

function QuoteBox({ quote }) {
  const { dateId } = quote;
  // const date = datetime.split(` `)[0];
  return (
    <div className="quote-box">
      <blockquote>{quote.quote}</blockquote>
      <div className="quote-by">
        - {quote.quoted}
        {quote.link_url && (
          <span>
            <a href={quote.link_url} target="_blank">
              <i className="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </span>
        )}
      </div>
      <div className="submitted-by">
        Submitted by {quote.user}
        {quote.date && (
          <div className="">
            on <Link to={`/quote/${dateId}`}>{quote.date}</Link>
          </div>
        )}
      </div>
    </div>
  );
}

export default QuoteBox;
